import { scroller } from 'react-scroll';
// ページ内スクロール（ヘッダーの高さ調整）
export const hotlineLpScrollToWithHeaderHeight = (name, ref, offset = 0) => {
    var _a;
    const options = {
        offset,
        smooth: true,
    };
    const height = ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
    options.offset -= height;
    return scroller.scrollTo(name, options);
};
